<template>
  <v-card>
    <v-card-title>
      <div class="layout row ma-0 justify-space-between pb-1">
        <div class="subheading">{{ title }}</div>
        <div class="icon">
          <v-icon :color="color">{{ icon }}</v-icon>
        </div>
      </div>
    </v-card-title>
    <v-card-text>
      <div class="justify-center row layout ma-0">
        <v-progress-circular
          :size="200"
          :width="12"
          :rotate="-90"
          :value="value"
          :color="value > 69 ? 'success' : 'error'"
        >
          <div class="display-2">{{ value }}%</div>
        </v-progress-circular>
      </div>
    </v-card-text>
    <v-divider v-if="$slots.actions" class="mx-3" />
    <v-card-actions>
      <slot name="actions" />
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    icon: String,
    title: String,
    subTitle: String,
    caption: String,
    value: String,
    color: String,
  },
};
</script>

<style></style>
